<template>
  <div
    v-if="options"
    class="sf-faq-category"
  >
    <div class="sf-faq-cat-header">
      <div class="sf-faq-cat-icon">
        <feather-icon
          :icon="options.icon"
          size="20"
        />
      </div>
      <div>
        <h4 class="sf-faq-cat-title">
          {{ options.titulo }}
        </h4>
        <span class="sf-faq-cat-subtitle">{{ options.subtitulo }}</span>
      </div>
    </div>

    <div class="sf-faq-list">
      <router-link
        v-for="( data,index) in options.faqList"
        :key="index"
        tag="div"
        class="sf-faq-item"
        :to="'/spot/faq/'+sanitizeTitle(options.titulo)+'/'+data.tituloNormalizado"
      >
        <span class="sf-faq-item-question">{{ data.pergunta }}</span>
        <feather-icon
          icon="ArrowRightCircleIcon"
          size="20"
          class="sf-faq-item-arrow"
        />
      </router-link>
    </div>

  </div>
</template>

<script>
import utilsMixin from '@/mixins/utilsMixin'

export default {

  mixins: [utilsMixin],

  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },

}
</script>

<style lang="scss" scoped>
.sf-faq-cat-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}
.sf-faq-cat-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: rgba(59, 130, 246, 0.12);
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.sf-faq-cat-title {
  font-family: 'Geist', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}
.sf-faq-cat-subtitle {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.50);
}

.sf-faq-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sf-faq-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  cursor: pointer;
  transition: border-color .15s ease, transform .15s ease;

  &:hover {
    border-color: rgba(59, 130, 246, 0.35);
    transform: translateY(-1px);
  }
}
.sf-faq-item-question {
  font-family: 'Geist', sans-serif;
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.4;
}
.sf-faq-item-arrow {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.35);
}
</style>
